import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

import { requireFeatureFlag } from 'lib/routeGuards'

import SubmitChallenge from 'pages/SubmitChallenge'

const submitChallengeSearchSchema = z.object({
  lat: z.coerce.number().optional(),
  lng: z.coerce.number().optional(),
})

export const Route = createFileRoute('/_auth/challenges/submit')({
  beforeLoad: requireFeatureFlag('challenges'),
  component: SubmitChallenge,
  validateSearch: zodValidator(submitChallengeSearchSchema),
})
